'use strict';

var _ = require('lodash');
var angular = require('angular');
var toastr = require('toastr');
var SeasonalityPanelController = function SeasonalityPanelController($scope, $log, dataRetrieverConstants, systemStatusCommonRenderer, configurationService, Calendar, seasonalityConstants, seasonRibbonDataProviderService, seasonalityOverridesSaveService, reinitializationService, $location, $anchorScroll, specialEventsService, gridDropdownPopulateService, userSecureService, featureToggleService, seasonalityEditCalendarUtilsService, momentService, newCalendarService) {
  var DEFAULT_DATE_FROM = 366;
  var DEFAULT_DATE_TO = 1;
  $scope.specialEventsGridId = seasonalityConstants.SPECIAL_EVENTS_GRID_ID;
  $scope.overrideMap = {};
  $scope.capturedEvents = [];
  $scope.screen = dataRetrieverConstants.SEASONALITY_SCREEN;
  $scope.customRenderers = systemStatusCommonRenderer;
  $scope.showSpecialEvents = false;
  $scope.displayedCalendar = {};
  $scope.isCalendarExpected = false;
  $scope.existingCalendar = undefined;
  $scope.isPooledSeasonalityEnabled = featureToggleService.isEnabled('POOLED_SEASONALITY');
  $scope.pooledSeasonalityReviewVisible = false;
  var initModelLabel = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY') ? seasonalityConstants.CALENDAR_MODES.DA_HSE : seasonalityConstants.CALENDAR_MODES.DEMAND;
  var initMode = featureToggleService.isEnabled('DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY') ? dataRetrieverConstants.SEASONALITY_DA_HOLIDAY_SPECIAL_EVENT : $scope.isPooledSeasonalityEnabled ? dataRetrieverConstants.SEASONALITY_POOLED_MODE : dataRetrieverConstants.SEASONALITY_DEMAND_MODE;
  $scope.displayedCalendarData = {};
  $scope.screenState = {
    searchResultMarkets: [],
    calendarModeLabel: initModelLabel,
    calendarMode: initMode
  };
  $scope.selectedRow = {};
  $scope.selectedRows = [];
  $scope.clearAdjModalConfig = {
    closeButtonPresent: false
  };
  $scope.isDemandSeasonality = function () {
    return _.includes([dataRetrieverConstants.SEASONALITY_DEMAND_MODE, dataRetrieverConstants.SEASONALITY_POOLED_MODE, dataRetrieverConstants.SEASONALITY_SHOW_UP_MODE], $scope.screenState.calendarMode);
  };
  $scope.showSeasonalityTab = function showSeasonalityTab(currentMode) {
    switch (currentMode) {
      case 'demand':
        return _.includes([dataRetrieverConstants.SEASONALITY_DEMAND_MODE, dataRetrieverConstants.SEASONALITY_POOLED_MODE, dataRetrieverConstants.SEASONALITY_SHOW_UP_MODE, dataRetrieverConstants.DA_SEASONALITY_SEASON_MODE], $scope.screenState.calendarMode);
      case 'hse':
        return $scope.screenState.calendarMode === dataRetrieverConstants.SEASONALITY_DA_HOLIDAY_SPECIAL_EVENT;
    }
    return true;
  };
  $scope.initScreen = function () {
    $log.debug('Initializing the Seasonality screen...');
    $scope.newCalendarPanel = {
      visible: false
    };
    $scope.eventsGrid = {
      visible: false
    };
  };
  $scope.closeReviewSeasonality = function (isClosedTemporarily) {
    $scope.updateLocalOverrides([]);
    $scope.isCalendarExpected = isClosedTemporarily ? $scope.isCalendarExpected : false;
    $scope.seasonalityAnalysisReviewPanelVisible = false;
    resetSPOSAndClsGroup();
    scrollToTop();
  };
  $scope.captureSpecialEventsFromGrid = function (data) {
    if (data.length > 0) {
      $scope.capturedEvents = data;
    }
  };
  $scope.buildPayLoad = function () {
    var market = $scope.selectedRow.market.split('-');
    return [{
      origin: market[0],
      destination: market[1],
      startDepartureDate: momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(DEFAULT_DATE_FROM, 'day'),
      endDepartureDate: momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(DEFAULT_DATE_TO, 'day'),
      calendarName: $scope.selectedRow.calendarName,
      triggeredFrom: 'SAVEBUTTON'
    }];
  };
  $scope.saveAndCloseReviewSeasonality = function () {
    //validate and capture special events
    var validationStatusForSpecialEvents = $scope.validateSpecialEvents();
    if (validationStatusForSpecialEvents === '_clear') {
      $scope.specialEventsOverrideConstructor();
      if ($scope.specialEventsOverride) {
        $scope.displayedCalendar.overrides.push($scope.specialEventsOverride);
      }
      $scope.demandReinitPayload = $scope.buildPayLoad();
      reinitializationService.countExternalOverridesInProgress().then(function (result) {
        if (!result) {
          $scope.triggerReinit();
        } else {
          $scope.showModal();
        }
      });
    } else {
      $log.error('SeasonalityPanelController: saveAndCloseReviewSeasonality - ' + validationStatusForSpecialEvents);
      toastr.error(validationStatusForSpecialEvents);
    }
  };
  function getSposList(poses) {
    return _.uniq(_.map(poses, function (filterPos) {
      return filterPos.spos;
    }));
  }
  function loadSposAndClassroup() {
    $scope.classGroupList = configurationService.getClassGroups();
    $scope.sposList = getSposList(configurationService.getPoses());
    $scope.cabinList = configurationService.getCabins();
    $scope.displayedCalendar.classGroup = $scope.classGroupList[0];
    $scope.displayedCalendar.spos = $scope.sposList[0];
    $scope.displayedCalendar.cabin = $scope.cabinList[0];
  }
  $scope.$on('$stateChangeSuccess', function () {
    loadSposAndClassroup();
    $scope.initScreen();
  });
  $scope.saveAndInitFunction = function () {
    var validationStatusForSpecialEvents = $scope.validateSpecialEvents();
    if (validationStatusForSpecialEvents !== '_clear') {
      $log.error('SeasonalityPanelController: saveAndInitFunction - ' + validationStatusForSpecialEvents);
      toastr.error(validationStatusForSpecialEvents);
      return;
    }
    var demandInitAndPartitionedSeasonality = !$scope.isPooledSeasonalityEnabled && $scope.screenState.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND;
    if (!demandInitAndPartitionedSeasonality) {
      $scope.specialEventsOverrideConstructor();
      angular.element('#save-and-initialize-modal').modal('show');
      return;
    }
    var origin = $scope.displayedCalendar.market.split('-')[0];
    var destination = $scope.displayedCalendar.market.split('-')[1];
    var marketData = _.find(configurationService.getMarkets(), {
      origin: origin,
      destination: destination
    });
    var markets = [{
      origin: origin,
      destination: destination,
      forecastType: _.get(marketData, 'forecastType', 'Market')
    }];
    reinitializationService.isDemandSmoothingAlphaAboveZero(markets).then(function (result) {
      if (result === true) {
        $scope.specialEventsOverrideConstructor();
        angular.element('#save-and-initialize-modal').modal('show');
      } else {
        $log.error('SeasonalityPanelController: saveAndInitFunction - Demand Smoothing % parameter is set to 0% for this market. Demand Initialization cannot be submitted.');
        toastr.error('Demand Smoothing % parameter is set to 0% for ' + result + ' market' + (result === 'all' ? 's' : '') + '. Demand Initialization cannot be submitted.');
      }
    }, function () {
      $log.error('SeasonalityPanelController: saveAndInitFunction - error when getting DemandSmoothingAlpha');
    });
  };
  $scope.$on('seasonality-analysis:save-and-initialize', function (event, payload) {
    //validate and capture special events
    if ($scope.specialEventsOverride) {
      $scope.displayedCalendar.overrides.push($scope.specialEventsOverride);
    }
    $scope.demandReinitPayload = payload;
    reinitializationService.countExternalOverridesInProgress().then(function (result) {
      if (!result) {
        $scope.triggerReinit(true);
      } else {
        $scope.showModal();
      }
    });
  });
  $scope.$on('pooled-seasonality:save-events-and-overrides', function (event, refreshGrid) {
    if (refreshGrid) {
      $scope.pooledSeasonalityReviewVisible = false;
    }
    var validationStatusForSpecialEvents = $scope.validateSpecialEvents();
    if (validationStatusForSpecialEvents === '_clear') {
      $scope.specialEventsOverrideConstructor();
      if ($scope.specialEventsOverride) {
        $scope.displayedCalendar.overrides.push($scope.specialEventsOverride);
      }
      seasonalityOverridesSaveService.saveChanges(getOverrideKeyForPooledSeasonality($scope.displayedCalendar), $scope.displayedCalendar.overrides, true).then(function () {
        toastr.success('Changes are successfully saved');
        if (refreshGrid) {
          $scope.$broadcast('grid:dataChanged');
        }
      })["catch"](function () {
        $log.error('SeasonalityPanelController: seasonalityOverridesSaveService.saveChanges - Request Failed');
        toastr.error('Request Failed');
      });
    } else {
      $log.error('SeasonalityPanelController: saveSpecialEvents - ' + validationStatusForSpecialEvents);
      toastr.error(validationStatusForSpecialEvents);
    }
  });
  $scope.triggerReinit = function (allowReadingForecastTypeFromRow) {
    seasonalityOverridesSaveService.saveChanges(getOverrideKey($scope.displayedCalendar), $scope.displayedCalendar.overrides, false).then(function () {
      toastr.success('Changes are successfully saved');
    }).then(function () {
      return reinitializationService.reinitializeRequest($scope.demandReinitPayload, $scope.screenState.calendarModeLabel, 'Calscreen', allowReadingForecastTypeFromRow);
    }).then(function () {
      toastr.success('Request Successfully Submitted');
      $scope.$broadcast('grid:dataChanged');
      $scope.seasonalityAnalysisReviewPanelVisible = false;
      $scope.originalSpecialEvents = null;
      $scope.capturedEvents = null;
      $scope.specialEventsOverride = null;
      $scope.selectedRow = null;
      scrollToTop();
    })["catch"](function () {
      $log.error('SeasonalityPanelController: seasonalityOverridesSaveService.saveChanges - Request Failed');
      toastr.error('Request Failed');
    });
  };
  function scrollToTop() {
    var old = $location.hash();
    $location.hash('seasonality-analysis-grid-container');
    $anchorScroll();
    $location.hash(old);
  }
  $scope.isInitializationInProgress = function (displayedCalendar) {
    return displayedCalendar.profileStatus === 'STARTED-PROCESSING' || displayedCalendar.profileStatus === 'NEW-REQUEST';
  };
  $scope.isCalendarInactive = function (displayedCalendar) {
    return displayedCalendar.calendarEntryStatus === seasonalityConstants.CALENDAR_STATUSES.INACTIVE;
  };
  $scope.clearData = function () {
    $scope.displayedCalendar = {};
    $scope.displayedCalendarData = {};
    $scope.ribbonData = {};
  };
  $scope.updateDisplayedCalendarData = function (calendar, selectedRow) {
    return _.extend(calendar, _.pick(selectedRow, ['market', 'calendarName', 'metric', 'level', 'startDepartureDate', 'endDepartureDate', 'outlierTolerance', 'profileStatus', 'calendarStatus', 'calendarEntryStatus', 'regressionTerms', 'learningProcess', 'saveButtonStatus', 'domainName']));
  };
  function rowEligibleForPublish(row) {
    return row.profileStatus === 'completed' && row.calendarEntryStatus === 'NOT_PUBLISHED_CALENDAR';
  }
  $scope.getPublishButtonEnabled = function (selectedRows) {
    if ($scope.isPooledSeasonalityEnabled) {
      $scope.selectedRows = [];
      if (selectedRows && selectedRows.length > 0) {
        _.forEach(selectedRows, function (row) {
          if (rowEligibleForPublish(row)) {
            $scope.selectedRows.push(row);
          }
        });
        if ($scope.selectedRows.length === selectedRows.length) {
          return true;
        }
      }
    }
    return false;
  };
  $scope.isReviewButtonEnabled = function (selectedRow) {
    return selectedRow.calendarStatus === seasonalityConstants.CALENDAR_STATUSES.FINISHED || selectedRow.calendarStatus === seasonalityConstants.CALENDAR_STATUSES.COMPLETED;
  };
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId) {
    if (gridId !== 'seasonality-demand-calendars' && gridId !== 'seasonality-pooled-calendars') {
      return;
    }
    $scope.publishButtonEnabled = $scope.getPublishButtonEnabled(selectedRows);
    if (selectedRows && selectedRows.length === 1) {
      var selectedRow = selectedRows[0];
      $scope.selectedRow = selectedRows[0];
      $scope.displayedCalendar = $scope.updateDisplayedCalendarData($scope.displayedCalendar, selectedRow);
      resetSPOSAndClsGroup();
      if ($scope.isReviewButtonEnabled(selectedRow)) {
        $scope.reviewButtonEnabled = true;
        if ($scope.isCalendarExpected) {
          $scope.reviewCalendar();
        }
      } else {
        $scope.reviewButtonEnabled = false;
        if ($scope.seasonalityAnalysisReviewPanelVisible) {
          $scope.closeReviewSeasonality($scope.isCalendarExpected);
        }
      }
      $scope.reloadAllData();
    } else {
      $scope.clearData();
      $scope.reviewButtonEnabled = false;
      $scope.isCalendarExpected = false;
      $scope.seasonalityAnalysisReviewPanelVisible = false;
      $scope.eventsGrid.visible = false;
    }
    gridDropdownPopulateService.setSpecialEventNames([]);
  });
  function resetSPOSAndClsGroup() {
    $scope.displayedCalendar.classGroup = _.includes($scope.displayedCalendar.level, 'Prod Grp') ? $scope.classGroupList[0] : null;
    $scope.displayedCalendar.spos = _.includes($scope.displayedCalendar.level, 'POS') ? $scope.sposList[0] : null;
  }
  function getDowGroups(dowGroups) {
    return _.map(dowGroups, function (dowGroup) {
      return {
        id: dowGroup.group,
        label: dowGroup.dow.join(',')
      };
    });
  }
  function getOverrideKey(calendar) {
    var market = calendar.market.split('-');
    return [calendar.calendarName, market[0], market[1]].join('/');
  }
  function getOverrideKeyForPooledSeasonality(calendar) {
    var market = calendar.market.split('-');
    return [calendar.calendarName, market[0], market[1], configurationService.getHostCarrier(), calendar.calendarEntryStatus === seasonalityConstants.CALENDAR_STATUSES.PUBLISHED || calendar.calendarEntryStatus === seasonalityConstants.CALENDAR_STATUSES.RUNNING].join('/');
  }
  $scope.updateLocalOverrides = function (overrideData) {
    var key = getOverrideKey($scope.displayedCalendar);
    $scope.overrideMap[key] = overrideData ? overrideData : [];
  };
  $scope.reviewCalendar = function () {
    if ($scope.screenState.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND && $scope.isPooledSeasonalityEnabled) {
      $scope.pooledSeasonalityReviewVisible = true;
    } else {
      $scope.isCalendarExpected = true;
      $scope.setUpCalendarOverrides();
      $scope.updateSpecialEventsData();
      $scope.seasonalityAnalysisReviewPanelVisible = true;
    }
  };
  $scope.pooledSeasonalityReviewComplete = function (event, refreshGrid) {
    $scope.pooledSeasonalityReviewVisible = false;
    if (refreshGrid) {
      $scope.$broadcast('grid:dataChanged');
    }
  };
  $scope.showParameterReview = function () {
    $scope.adjustmentModalCaption = 'Publish Calendars';
    $scope.selectedRows.forEach(function (row) {
      row.includeForPublish = true;
    });
    $scope.$broadcast('rm-modal:show', 'clear-demand-adjustments');
  };
  $scope.publishCalendar = function (event, clearDemand, calendars) {
    $scope.pooledSeasonalityReviewVisible = false;
    newCalendarService.publishPooledSeasonalityCalendars(calendars, clearDemand).then(onRequestPublishSuccess, onRequestFail);
  };
  function onRequestPublishSuccess() {
    $scope.publishButtonEnabled = false;
    toastr.success('Request Successfully Submitted');
    $scope.$broadcast('grid:dataChanged');
  }
  function onRequestFail() {
    $log.error('Publish Calendar Request Failed - An error has occurred. Please try again');
    toastr.error('An error has occurred. Please try again.');
  }
  $scope.$on('seasonality-analysis:override-data-change', function (event, overrideData) {
    $scope.updateLocalOverrides(overrideData);
    $scope.updateRibbonData();
  });
  $scope.reloadAllData = function () {
    $scope.loadCalendarData().then(function () {
      $scope.updateRibbonData();
      $scope.updateSpecialEventsData();
    });
  };
  function overrideUniqKey(override) {
    var uniqueSelection = [];
    if ($scope.isPooledSeasonalityEnabled && $scope.screenState.calendarModeLabel === seasonalityConstants.CALENDAR_MODES.DEMAND) {
      uniqueSelection = ['cabin', 'dowGroup', 'marketSpecialEvents', 'significantPOS', 'weekNo', 'year'];
    } else {
      uniqueSelection = ['classGroup', 'dowGroup', 'marketSpecialEvents', 'significantPOS', 'weekNo', 'year'];
    }
    return _.chain(override).pick(uniqueSelection).values().compact().join('-').value();
  }
  $scope.setUpCalendarOverrides = function () {
    var overrideKey = getOverrideKey($scope.displayedCalendar);
    var storedOverrides = $scope.displayedCalendarData.seasonalityOverrides || [];
    var localOverrides = $scope.overrideMap[overrideKey] || [];
    var storedOverrideMap = _.keyBy(storedOverrides, overrideUniqKey);
    var localOverrideMap = _.keyBy(localOverrides, overrideUniqKey);
    var mergedOverrideMap = _.assign(storedOverrideMap, localOverrideMap);
    $scope.displayedCalendar.overrides = _.values(mergedOverrideMap);
  };
  $scope.loadCalendarData = function () {
    var cal = $scope.displayedCalendar;
    return seasonRibbonDataProviderService.getData(cal.market, cal.calendarName, $scope.screenState.calendarModeLabel).then(function (data) {
      $scope.displayedCalendarData = data && data[0] || {};
      $scope.displayedCalendar.dowGroupList = getDowGroups($scope.displayedCalendarData.dowGroups);
      $scope.displayedCalendar.selectedDow = $scope.displayedCalendar.dowGroupList[0];
      $scope.setUpCalendarDetails();
      $scope.setUpCalendarOverrides();
    });
  };
  $scope.updateRibbonData = function () {
    var cal = $scope.displayedCalendar;
    $scope.ribbonData = seasonRibbonDataProviderService.transformDataForSOW($scope.displayedCalendarData, cal.spos, cal.classGroup, $scope.displayedCalendar.overrides);
  };
  $scope.setUpCalendarDetails = function () {
    var calendarDetails = _.pick($scope.displayedCalendarData, ['maxOptimalSeasons', 'minOptimalSeasons', 'seasonalityLevel', 'seasonalityVariable', 'optimalSeasonCutoffCV', 'smoothingNumberOfWeeks', 'dowGroups']);
    $scope.displayedCalendar = _.extend($scope.displayedCalendar, calendarDetails);
  };
  $scope.updateSpecialEventsData = function () {
    var events = $scope.displayedCalendarData.specialEvents;
    $scope.displayedCalendar.specialEvents = specialEventsService.dataPrepForSpecialEvents(events, $scope.displayedCalendar.market);
    $scope.originalSpecialEvents = _.cloneDeep($scope.displayedCalendar.specialEvents);
    var specialEventsDropdownOptions = _.chain($scope.displayedCalendar.specialEvents).filter({
      eventType: 'Moving'
    }).map('eventName').uniq().value();
    gridDropdownPopulateService.setSpecialEventNames(specialEventsDropdownOptions);
    $scope.eventsGrid.visible = true;
    $scope.$broadcast('grid:loadData:seasonality-special-events');
  };
  $scope.$watchGroup(['displayedCalendar.spos', 'displayedCalendar.classGroup'], $scope.updateRibbonData);
  $scope.submitNewCalendar = function () {
    $scope.newCalendarPanel.visible = false;
    $scope.$broadcast('grid:reinitialize:seasonality-demand-calendars');
  };
  $scope.submitNewPooledSeasonalityCalendar = function () {
    $scope.newCalendarPanel.visible = false;
    $scope.$broadcast('grid:reinitialize:seasonality-pooled-calendars');
  };
  $scope.isSposComboboxVisible = function () {
    var level = seasonalityConstants.LEVEL_TO_SEASONALITY_LEVEL[$scope.displayedCalendar.level];
    return level === 'MARKET_CLASSGROUP_SPOS' || level === 'MARKET_SPOS';
  };
  $scope.isClassGroupComboboxVisible = function () {
    var level = seasonalityConstants.LEVEL_TO_SEASONALITY_LEVEL[$scope.displayedCalendar.level];
    return level === 'MARKET_CLASSGROUP_SPOS' || level === 'MARKET_CLASSGROUP';
  };
  $scope.isFilterVisible = function () {
    var level = seasonalityConstants.LEVEL_TO_SEASONALITY_LEVEL[$scope.displayedCalendar.level];
    return level === 'MARKET_CLASSGROUP_SPOS' || level === 'MARKET_CLASSGROUP' || level === 'MARKET_SPOS' && featureToggleService.isEnabled('SPOS');
  };
  $scope.validateSpecialEvents = function () {
    var specialEvents = $scope.displayedCalendar.specialEvents;
    var validationStatusForSpecialEvents = '_clear';
    if (specialEvents && specialEventsService.detectEventTypesInSpecialEvents(specialEvents, 'Moving')) {
      validationStatusForSpecialEvents = specialEventsService.validateDemandCalendarSpecialEventsGrid(specialEvents);
    }
    return validationStatusForSpecialEvents;
  };
  $scope.specialEventsOverrideConstructor = function () {
    $scope.specialEventsOverride = null;
    var specialEvents = $scope.displayedCalendar.specialEvents;
    var changedSpecialEvents = specialEventsService.detectChangedEvents($scope.originalSpecialEvents, specialEvents);
    if (changedSpecialEvents && changedSpecialEvents.length) {
      $scope.specialEventsOverride = specialEventsService.createSpecialEventsOverride(changedSpecialEvents, $scope.displayedCalendar.market);
    }
  };
  $scope.openNewCalendar = function () {
    $scope.newCalendarPanel.visible = true;
  };
  $scope.createNewCalendar = function () {
    $scope.editedCalendar = seasonalityEditCalendarUtilsService.getNewCalendar($scope.screenState.calendarModeLabel);
    $scope.openNewCalendar();
  };
  $scope.copyCalendar = function () {
    $scope.editedCalendar = seasonalityEditCalendarUtilsService.getCalendarCopy($scope.displayedCalendar, $scope.screenState.calendarModeLabel);
    $scope.openNewCalendar();
  };
  $scope.isDemandInitPermissionMissing = function () {
    return !userSecureService.hasAuthorization('demand-initialization');
  };
  $scope.wasSaveButtonClicked = function (displayedCalendar) {
    return !!displayedCalendar.saveButtonStatus;
  };
  $scope.isSaveButtonDisabled = function () {
    return $scope.isInitializationInProgress($scope.displayedCalendar) || $scope.wasSaveButtonClicked($scope.displayedCalendar) || $scope.isDemandInitPermissionMissing() || $scope.isCalendarInactive($scope.displayedCalendar);
  };
  $scope.getSaveButtonHoverOverMessage = function (defaultLabel) {
    if (!$scope.isSaveButtonDisabled($scope.displayedCalendar)) {
      return defaultLabel;
    }
    if ($scope.isInitializationInProgress($scope.displayedCalendar)) {
      return 'Initialization is in progress';
    }
    if ($scope.wasSaveButtonClicked($scope.displayedCalendar)) {
      return 'Save button action is in progress';
    }
    if ($scope.isCalendarInactive($scope.displayedCalendar)) {
      return 'Calendar is inactive';
    }
    if ($scope.isDemandInitPermissionMissing()) {
      return 'No access';
    }
    return 'Disabled';
  };
};
SeasonalityPanelController.$inject = ['$scope', '$log', 'DataRetrieverConstantsService', 'SystemStatusCommonRendererFactory', 'ConfigurationService', 'CalendarFactory', 'SeasonalityConstants', 'SeasonRibbonDataProviderService', 'SeasonalityOverridesSaveService', 'ReinitializationService', '$location', '$anchorScroll', 'SpecialEventsService', 'GridDropdownPopulateService', 'UserSecureService', 'FeatureToggleService', 'SeasonalityEditCalendarUtilsService', 'MomentService', 'NewCalendarService'];
module.exports = SeasonalityPanelController;